String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

Window.prototype.queryParam = function (name) {
    const url = this.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

Array.prototype.pluck = function(key) {
    return this.map(function(object) { return object[key]; });
};

String.prototype.removeTagsHtml = function() {
    return this.replace(/\n|<.*?>/g,'');
}